import React from 'react';
import styled from 'styled-components';

const ActivitiesContainer = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
`;

const Title = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 1rem;
`;

const ActivityItem = styled.div`
  padding: 0.75rem 0;
  border-bottom: 1px solid #f3f4f6;
  &:last-child { border-bottom: none; }
`;

const ActivityType = styled.span`
  font-weight: 500;
  color: #2563eb;
  margin-right: 0.5rem;
`;

const mockActivities = [
  { id: 1, type: 'Assignment', desc: 'Created "Heart Structure" assignment for Grade 7A', time: '2h ago' },
  { id: 2, type: 'Lesson', desc: 'Scheduled lesson on "Photosynthesis" for Grade 4', time: '4h ago' },
  { id: 3, type: 'Intervention', desc: 'Scheduled intervention for Mary Johnson', time: '1d ago' },
  { id: 4, type: 'Announcement', desc: 'Sent announcement to all Grade 7 students', time: '2d ago' },
];

const RecentActivities: React.FC = () => (
  <ActivitiesContainer>
    <Title>Recent Activities</Title>
    {mockActivities.map(act => (
      <ActivityItem key={act.id}>
        <ActivityType>{act.type}:</ActivityType>
        {act.desc} <span style={{ color: '#6b7280', fontSize: '0.85em', marginLeft: 8 }}>{act.time}</span>
      </ActivityItem>
    ))}
  </ActivitiesContainer>
);

export default RecentActivities; 